export default __webpack_public_path__ + "static/media/usergroup-add.5adb254d.svg";